import React from 'react';
import styles from '../../../styles/templates/custom-page/trust-card.module.scss';
import { Image } from '../../../components/images/image';
import { AffiliateIcon } from '../../../components/icons/affiliate-icon';
import { ConfigService } from '../../../services/config-service';

const Entry = React.memo(({ icon, title, children }) => (
  <div className={styles.item}>
    <div className={styles.info}>
      <AffiliateIcon name={icon} className={styles.icon} />
      <p className={styles.heading}>{title}</p>
    </div>
    <p className={styles.description}>{children}</p>
  </div>
));

export const TrustCard = React.memo(({ name, image, firstBar, secondBar, regulator }) => {
  const { title, firstRow, secondRow, thirdRow } = ConfigService.get('COMPONENTS.TRUST_CARD', {});

  return (
    <article className={styles.container}>
      <div className={styles.header}>
        {image && <Image src={image.url} alt={image.alt} className={styles.image} />}
        <div className={styles.partner}>
          <p className={styles.title}>{title}</p>
          <p className={styles.name}>{name}</p>
        </div>
      </div>
      <div className={styles.body}>
        {firstBar && (
          <Entry icon='trust-why-we-like-them' title={firstRow}>
            {firstBar}
          </Entry>
        )}
        {secondBar && (
          <Entry icon='trust-how-we-make-money' title={secondRow}>
            {secondBar}
          </Entry>
        )}
        {regulator && (
          <Entry icon='trust-the-legal-bit' title={thirdRow}>
            {regulator}
          </Entry>
        )}
      </div>
    </article>
  );
});
